import React, { useState, useEffect } from 'react';
import Sidebar from './sidebar';
import MainArea from './MainArea';
import Navbar from './navbar';
import BeforeSelect from './BeforeSelect';
import BatchAndEval from './batchAndEval';
import 'react-reflex/styles.css';
import { ReflexContainer, ReflexElement, ReflexSplitter } from 'react-reflex';
import { CollapsedSideBar } from './collapsedSideBar';
import { faFolder, faLayerGroup, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import TransactionList from './Transactionlist';
import { useGlobalCredits } from '../context/GlobalStateContext';
import { DataType } from '../enums';
import { Modal } from '@quyva/shared-ui';
import { BatchType } from '@quyva/common';
const Main = ({
    isAdmin,
    setIsAdmin,
    newNotification,
    setNewNotification,
    fetchTemplateList,
    setTemplateList,
    setActiveTemplate,
    viewNotifications,
    setViewNotifications,
    messages,
    socket,
    processingRepos,
    isSideViewExpanded,
    setIsSideViewExpanded,
    templateList,
    fileToChat,
    setFileToChat,
    repo_to_chat,
    set_repo_to_chat,
    chat_selected,
    set_chat_selected,
    workOnRepo,
    setWorkOnRepo,
    isRepoSortedAlphabetically,
    setIsRepoSortedAlphabetically,
    planName
}) => {
    const user = JSON.parse(localStorage.getItem('current'));
    const [fine_tuned_chat, set_fine_tuned_chat] = useState(false);
    const [batchmode, setBatchmode] = useState(false);
    const [batchType, setBatchType] = useState(null);

    useEffect(() => {
        document.body.style.overflow = batchmode ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [batchmode]);

    const [isMobile, setIsMobile] = useState(false);
    //responsive mode functions and variables
    const [showPdf, setShowPdf] = useState(false);
    const [onButton, setOnButton] = useState(false);
    useEffect(() => {
        // Reset both states to false when the component mounts or updates
        setShowPdf(false);
        setOnButton(false);
        fetchTemplateList(user, setActiveTemplate, setTemplateList);
    }, []);

    const togglePdfVisibility = (reset) => {
        if (typeof reset === DataType.STRING) {
            setShowPdf(false);
            setOnButton(false);
        } else {
            setShowPdf((prevState) => !prevState);
            setOnButton((prevState) => !prevState);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024); // Change 1024 to your desired breakpoint
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const { transactionMode, setTransactionMode } = useGlobalCredits();
    const updateRepoToChat = (value) => {
        set_repo_to_chat(value);
    };

    return (
        <>
        <div className='z-0 w-screen h-screen p-2 overflow-hidden'>
            <ReflexContainer orientation='vertical'>
                {!isMobile && (
                    <ReflexElement
                        className='left-pane mr-0.5'
                        minSize={isSideViewExpanded ? 250 : 50}
                        size={isSideViewExpanded ? 350 : 50}
                        maxSize={isSideViewExpanded ? 700 : 50}
                    >
                        <div className='pane-content w-full h-full bg-transparent'>
                            {isSideViewExpanded ? (
                                <div className='w-full h-full border border-2 overflow-auto bg-backgrounds-slate rounded-xl p-2 z-10'>
                                    <Sidebar
                                        chatrepo={repo_to_chat}
                                        planName={planName}
                                        templateList={templateList}
                                        chatrepofunction={updateRepoToChat}
                                        set_fine_tuned={set_fine_tuned_chat}
                                        fine_tune={fine_tuned_chat}
                                        fileToChat={fileToChat}
                                        setFileToChat={setFileToChat}
                                        setIsRepoViewExpanded={
                                            setIsSideViewExpanded
                                        }
                                        isAdmin={isAdmin}
                                        setIsAdmin={setIsAdmin}
                                        mode={'qna'}
                                        socket={socket}
                                        processingRepos={processingRepos}
                                        setViewNotifications={
                                            setViewNotifications
                                        }
                                        isSmallScreen={isMobile}
                                        chat_selected={chat_selected}
                                        set_chat_selected={set_chat_selected}
                                        workOnRepo={workOnRepo}
                                        setWorkOnRepo={setWorkOnRepo}
                                        isRepoSortedAlphabetically={
                                            isRepoSortedAlphabetically
                                        }
                                        setIsRepoSortedAlphabetically={
                                            setIsRepoSortedAlphabetically
                                        }
                                        onBatchOpen={(repo, type) => {
                                            updateRepoToChat(repo);
                                            setBatchmode(true);
                                            setBatchType(type);
                                        }}
                                    />
                                </div>
                            ) : (
                                <CollapsedSideBar
                                    icon={faFolder}
                                    planName={planName}
                                    iconColor={'icons-primary'}
                                    title={'Repositories'}
                                    setIsRepoViewExpanded={
                                        setIsSideViewExpanded
                                    }
                                />
                            )}
                        </div>
                    </ReflexElement>
                )}

                {!isMobile && (
                    <ReflexSplitter
                        style={{
                            border: 0,
                            background: 'white',
                            width: '6px',
                            zIndex: 10,
                            height: '98vh',
                        }}
                    />
                )}

                <ReflexElement className='right-pane ml-0.5'>
                    <div className='pane-content w-full h-full bg-transparent'>
                        <div className='w-full h-full border border-2 overflow-auto bg-backgrounds-slate rounded-xl z-0'>
                            <ReflexContainer orientation='horizontal'>
                                <ReflexElement
                                    className='header'
                                    style={{
                                        minHeight: '4rem',
                                        height: '4rem',
                                        maxHeight: '4rem',
                                    }}
                                >
                                    <div className='pane-content w-full h-full p-2'>
                                        <Navbar
                                            isAdmin={isAdmin}
                                            repo_to_chat={repo_to_chat}
                                            updateRepoToChat={updateRepoToChat}
                                            set_fine_tuned_chat={
                                                set_fine_tuned_chat
                                            }
                                            fine_tuned_chat={fine_tuned_chat}
                                            fileToChat={fileToChat}
                                            setFileToChat={setFileToChat}
                                            setIsRepoViewExpanded={
                                                setIsSideViewExpanded
                                            }
                                            setIsAdmin={setIsAdmin}
                                            mode={'qna'}
                                            newNotification={newNotification}
                                            setNewNotification={
                                                setNewNotification
                                            }
                                            viewNotifications={
                                                viewNotifications
                                            }
                                            setViewNotifications={
                                                setViewNotifications
                                            }
                                            messages={messages}
                                            socket={socket}
                                            processingRepos={processingRepos}
                                            togglePdfVisibility={
                                                togglePdfVisibility
                                            }
                                            isSmallScreen={isMobile}
                                            isRepoSortedAlphabetically={
                                                isRepoSortedAlphabetically
                                            }
                                            setIsRepoSortedAlphabetically={
                                                setIsRepoSortedAlphabetically
                                            }
                                        />
                                    </div>
                                </ReflexElement>

                                <ReflexElement flex={1}>
                                    <div className='pane-content h-full w-full p-2'>
                                        {transactionMode ? (
                                            <>
                                                <TransactionList />
                                            </>
                                        ) : (
                                            <>
                                                {repo_to_chat !== -1 ? (
                                                    <MainArea
                                                        showPdf={showPdf}
                                                        onButton={onButton}
                                                        setShowPdf={setShowPdf}
                                                        setOnButton={
                                                            setOnButton
                                                        }
                                                        togglePdfVisibility={
                                                            togglePdfVisibility
                                                        }
                                                        socket={socket}
                                                        repo_to_chat={
                                                            repo_to_chat
                                                        }
                                                        fine_tuned_mode={
                                                            fine_tuned_chat
                                                        }
                                                        fileToChat={fileToChat}
                                                        isAdmin={isAdmin}
                                                        isSmallScreen={isMobile}
                                                        processingRepos={
                                                            processingRepos
                                                        }
                                                    />
                                                ) : (
                                                    <BeforeSelect />
                                                )}
                                            </>
                                        )}
                                    </div>
                                </ReflexElement>
                            </ReflexContainer>
                        </div>
                    </div>
                </ReflexElement>
            </ReflexContainer>
        </div>

        {batchmode && (
            <Modal
                title={batchType === BatchType.QNA ? 'Batch' : 'Batch & Extract'}
                titleIcon={batchType === BatchType.QNA ? faLayerGroup : faClipboardCheck}
                onClose={() => { setBatchmode(false); setBatchType(null); }}
            >
                <div className='w-[80vw] max-w-4xl'>
                    <BatchAndEval
                        batchType={batchType}
                        repo_to_chat={repo_to_chat}
                        onCancel={() => { setBatchmode(false); setBatchType(null); }}
                    />
                </div>
            </Modal>
        )}
        </>
    );
};

export default Main;
